import { axiosWrapper } from "../../axiosWrapper";

export interface IQuoteProcessingMetricsPayload {
  records: number;
  skip: number;
  searchText?: string;
}

export interface IQuoteProcessingMetricsResponse {
  id: string;
  partitionKey: string;
  quotationNumber: string;
  country: string;
  region: string;
  userSessionStartTime: string | null;
  fillQuoteDetails: number | null;
  cartPrepration: number | null;
  quoteCreationDuration: number | null;
  editQuoteSessionTime: number | null;
  totalQuoteProcessTime: number | null;
  totalSessionTimeinSeconds: number | null;
  totalTabsCount: number | null;
  userSessionEndTime: string | null;
  customerName: string;
  createdByName: string;
  createdAt: string;
  status: string;
  
  // Edit tracking fields
  editQuoteCount: number | null;
  totalCumulativeEditTime: number | null;
  totalCumulativeEditProcessTime: number | null;
  
  // Consolidated timing fields (combining create + edit data)
  consolidatedTotalTimeSeconds: number | null;
  consolidatedAwayTimeSeconds: number | null;
  consolidatedIdleTimeSeconds: number | null;
  consolidatedProductiveTimeSeconds: number | null;
}

export class QuoteProcessingMetricsService {
  public static async getQuoteProcessingMetrics(metricsPayload: IQuoteProcessingMetricsPayload) {
    return await axiosWrapper.Post(`Quotations/ProcessingMetrics`, metricsPayload);
  }

  public static async getQuoteProcessingMetricsFromCosmos(fromDate?: Date, toDate?: Date) {
    let url = `Quotations/ProcessingMetricsFromCosmos`;
    const params = new URLSearchParams();
    
    if (fromDate) {
      params.append('fromDate', fromDate.toISOString());
    }
    
    if (toDate) {
      params.append('toDate', toDate.toISOString());
    }
    
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    return await axiosWrapper.Get(url);
  }
}
